import React from 'react';
import UserJourney from '../../user-journey/pages/UserJourney';

/**
 * History/UserJourney - Frontend implementation with demo data
 */
const History = ({ onMenuClick, onClose, screenSize, siteId: defaultSiteId }) => {
  return <UserJourney onMenuClick={onMenuClick} screenSize={screenSize} selectedPage="history" />;
};

export default History;
